module.exports = __webpack_public_path__ + "img/0xd63604d2698F763144092C325C9Cd9Fe518C1a20.54c32ace.png";